<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <v-card v-if="casoDeUso" class="mx-4 mt-4">
    <v-row align-content="space-between">
      <v-col cols="6">
        <v-card-title class="font-weight-bold">
          {{ this.projeto }}
        </v-card-title>

        <div class="text-h5 ml-4">
          {{ casoDeUso.identificador }} - {{ casoDeUso.nome }}
        </div>
      </v-col>

      <v-col cols="6">
        <v-card-actions class="d-flex justify-end">
          <div class="d-flex align-center">
            <EditCSU
              v-if="isDev"
              @caso-de-uso-editado="
                (newId) => {
                  this.id = newId;
                }
              "
              @rascunho-salvo="fetchCasoDeUso"
              :casoDeUsoP="this.casoDeUsoFormatado"
              :id="this.id"
              text="Editar"
              color="orange"
            />

            <v-btn
              v-if="isDev"
              class="ml-6"
              color="error"
              @click="showDialog = true"
              append-icon="mdi-delete-outline"
              >Excluir</v-btn
            >
          </div>
        </v-card-actions>
      </v-col>
    </v-row>

    <div class="ml-4 text-subtitle-2 mt-1 mb-2">
      <span v-if="casoDeUso.prioridade">
        Prioridade:
        <span class="font-weight-bold mr-3 ml-2 text-black">{{
          converterEnumParaTexto(casoDeUso.prioridade)
        }}</span>
      </span>
      <span v-if="casoDeUso.storypoint">
        Storypoint:
        <span class="text-black ml-2 mr-3 font-weight-bold">{{
          casoDeUso.storypoint
        }}</span>
      </span>
      <span class="mr-3"
        >Status:
        <span class="font-weight-bold ml-2 text-black text-capitalize">{{
          casoDeUso.status.toLowerCase()
        }}</span>
      </span>
      <span
        >Criado em: <span class="ml-2 text-black">{{ dataFormatada }}</span>
      </span>
    </div>

    <div class="mt-4 ml-4">
      <RouterLink
        :to="'/projects/' + this.idProjeto + '/CasoUso/' + this.id + '/Bugs'"
      >
        <v-btn :class="isQA ? '' : 'ml-2'" color="grey-darken-3" variant="tonal"
          >Bugs</v-btn
        >
      </RouterLink>

      <ModalListCharters :id="this.id" />
      <CreateImplementacao v-if="isDev" :id="this.id" />
      <VisualizarImplementacao v-if="!isQA" :id="this.id" />
      <!-- <v-btn
        class="text-none"
        color="blue-darken-4"
        rounded="0"
        variant="outlined"
        v-bind="props"
      >
        Manage Cookies
      </v-btn> -->
    </div>

    <div class="mt-3 mx-4">
      <div class="mt-1 mb-2 text-light-blue-darken-4">Gatilho</div>
      <div class="rounded-sm bg-grey-lighten-4 px-1 py-2">
        <p class="ml-2 text-body-1">{{ casoDeUso.gatilho }}</p>
      </div>
      <div class="mt-1 mb-2 text-light-blue-darken-4">Pré-condição</div>
      <div class="rounded-sm bg-grey-lighten-4 px-1 py-2">
        <p class="ml-2 text-body-1">{{ casoDeUso.pre_condicao }}</p>
      </div>
      <div class="mt-1 mb-2 text-light-blue-darken-4">Descrição</div>
      <div class="rounded-sm bg-grey-lighten-4 px-1 py-2">
        <p class="ml-2 text-body-1">
          {{ casoDeUso.descricao }}
        </p>
      </div>
      <div>
        <div class="mt-1 mb-2 text-light-blue-darken-4">
          <div class="d-flex">
            Atores
            <AtorCSU
              v-if="isDev"
              @ator-adicionado="fetchAtores"
              class="ml-2"
              :id="this.id"
            />
          </div>
        </div>
      </div>
      <div class="rounded-sm bg-grey-lighten-4 px-1 py-2">
        <p class="ml-2 text-body-1">
          {{ atoresString ? atoresString : 'Nenhum Ator definido.' }}
        </p>
      </div>
    </div>

    <div class="bg-light-blue-darken-4 my-4 mydivider mx-4"></div>
    <v-row class="ml-0" align-content="center">
      <v-card-title class="font-weight-bold"
        >Requisitos Relacionados</v-card-title
      >
      <AssociarRequisitoAoCSU
        v-if="isDev"
        @requisitos-associados="getRequisitosByCasoDeUso"
      />
    </v-row>

    <v-table
      class="ma-8 mt-10 req--table elevation-1"
      style="background: transparent"
      height="300"
      fixed-header="true"
      density="comfortable"
    >
      <thead class="text-grey">
        <tr>
          <th class="text-center text-grey">Requisito</th>
          <th
            style="border-left: thin solid #efefef"
            class="text-center text-grey"
          >
            Descrição
          </th>
          <th
            style="border-left: thin solid #efefef"
            class="text-center text-grey"
          >
            Tipo
          </th>
          <th
            style="border-left: thin solid #efefef"
            class="rounded-te-lg text-center text-grey"
          >
            Observação
          </th>
          <th
            style="border-left: thin solid #efefef"
            class="text-left text-grey"
          >
            Ações
          </th>
        </tr>
      </thead>
      <div class="split"></div>
      <tbody>
        <tr v-for="item in requisitos" :key="item">
          <td class="text-center">
            <router-link
              :to="
                '/projects/' +
                this.idProjeto +
                '/Requisitos/' +
                item.id_requisito
              "
              ><p class="text-decoration-underline">
                {{ item.identificacao }}
              </p></router-link
            >
          </td>

          <td style="border-left: thin solid #efefef" class="text-center">
            {{ item.descricao }}
          </td>

          <td style="border-left: thin solid #efefef" class="text-center">
            {{ converterEnumParaTexto(item.tipo_requisito) }}
          </td>

          <td style="border-left: thin solid #efefef" class="text-center">
            {{ item.observacao }}
          </td>
          <td style="border-left: thin solid #efefef" class="text-left">
            <RouterLink
              :to="
                '/projects/' +
                this.idProjeto +
                '/Requisitos/' +
                item.id_requisito
              "
            >
              <v-icon
                size="large"
                color="green-darken-2"
                icon="mdi-eye-arrow-right-outline"
              ></v-icon>
            </RouterLink>
          </td>
        </tr>
        <tr v-if="this.isLoadingRequisitos">
          <td></td>
          <td></td>
          <td class="text-center">
            <v-progress-circular class="text-center" indeterminate size="20" />
          </td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </v-table>
    <!-- <v-card-text class="mt-6">
      <v-row class="mb-2">
        <span class="text-h6 ml-3 my-4 mb-4 mr-4">Atores</span>
      </v-row>
      <div class="ml-2">
        {{ atoresString ? atoresString : 'Nenhum Ator definido.' }}
      </div>
    </v-card-text> -->
    <v-row align-content="center" class="mt-5">
      <v-card-title class="mx-3 font-weight-bold"
        >Fluxos do Caso de Uso</v-card-title
      >
      <CreateFluxo
        v-if="isDev"
        :key="keyCreateFluxo"
        @fluxo-adicionado="onFluxosAlterados"
        :id="this.id"
      />
    </v-row>

    <FluxoCasoUso
      @fluxo-editado="onFluxosAlterados"
      @fluxo-removido="onFluxosAlterados"
      class="mb-4"
      v-for="(fluxo, index) in fluxos"
      :key="fluxo.descricao"
      :fluxo="fluxo"
      :index="index"
    ></FluxoCasoUso>

    <v-row class="ml-0" align-content="center">
      <v-card-title class="font-weight-bold"
        >Este caso de uso depende dos seguintes casos de uso:</v-card-title
      >
    </v-row>

    <DependenciasMap
      :refetchCSU="() => this.fetchCasoDeUso(this.id)"
      :id="id"
      :dependencias="casoDeUso.dependencias"
    />

    <DependenciaCSU
      :conteudo-modal-dep="conteudoModalDep"
      :toggle-show-dialog-dep="toggleShowDialogDep"
      :dialog-dep="showDialogDep"
    />

    <HistoricoCSU :key="keyHistorico" :csuID="id"></HistoricoCSU>
  </v-card>

  <v-dialog v-model="showDialog" max-width="500">
    <v-card>
      <v-card-title class="headline"> Confirmação de Remoção </v-card-title>

      <v-card-text>
        Você tem certeza que deseja remover este caso de uso?
      </v-card-text>

      <v-card-actions>
        <v-btn color="red darken-1" dark @click="deleteCasoDeUso(casoDeUso)"
          >Sim</v-btn
        >
        <v-btn color="blue darken-1" dark @click="showDialog = false"
          >Não</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-container v-if="this.isLoading" class="d-flex justify-center align-center">
    <v-progress-circular class="text-center" indeterminate size="20" />
  </v-container>
</template>

<script>
/**
 * @module CasoDeUso
 * @desc Componente que mostra detalhes sobre um determinado caso de uso.
 * @vue-data {Object} [casoDeUso=null] Objeto que representa o caso de uso
 * @vue-data {Array.<Object>} [fluxos=null] Lista que armazena os fluxos
 * do caso de uso
 * @vue-data {String} [atoresString=''] String contendo os nomes dos
 * atores separados por vírgula
 * @vue-data {String} [id=null] Armazena o id do caso de uso
 * @vue-data {String} [idProjeto=null] Armazena o id do projeto onde o
 * caso de uso está
 * @vue-data {String} [projeto=''] - Nome do projeto
 * @vue-data {Boolean} [showDialog=false] Flag que determina se o modal de
 * remoção do caso de uso está visível
 * @vue-data {Boolean} [showDialogDep=false] Flag que indica se o modal
 * que mostra detalhes da dependência está visível
 * @vue-data {Object} [conteudoModalDep=null] Objeto com o conteúdo do
 * modal que mostra detalhes da dependência
 * @vue-data {boolean} [isLoading=false] - Indica se o caso de uso
 * está sendo carregado ou não
 * @vue-data {Number} [keyHistorico=0] - Chave do componente de histórico
 * @vue-computed {Object} casoDeUsoFormatado - Objeto que possui as mesmas
 * informações que casoDeUso, mas formatadas
 * @vue-computed {Boolean} isDev - Flag que indica se o usuário
 * atual é desenvolvedor no projeto
 * @vue-computed {Boolean} isQA - Flag que indica se o usuário
 * atual é testador no projeto
 */
import axios from 'axios';

import DependenciasMap from '@/components/DependenciasMap.vue';
import AssociarRequisitoAoCSU from '@/components/dialogs/AssociarRequisitoAoCSU.vue';
import AtorCSU from '@/components/dialogs/AtorCSU.vue';
import CreateFluxo from '@/components/dialogs/CreateFluxo.vue';
import CreateImplementacao from '@/components/dialogs/CreateImplementacao.vue';
import DependenciaCSU from '@/components/dialogs/DependenciaCSU.vue';
import EditCSU from '@/components/dialogs/EditCSU.vue';
import ModalListCharters from '@/components/dialogs/ModalListCharters.vue';
import VisualizarImplementacao from '@/components/dialogs/VisualizarImplementacoes.vue';
import FluxoCasoUso from '@/components/FluxoCasoUso.vue';
import HistoricoCSU from '@/components/HistoricoCSU.vue';
import store from '@/store/store';

const apiUrl = process.env.VUE_APP_API_URL;
// mude a porta no dotenv, não se esqueça de como tá escrito aqui
export default {
  components: {
    FluxoCasoUso,
    EditCSU,
    CreateFluxo,
    CreateImplementacao,
    VisualizarImplementacao,
    DependenciaCSU,
    HistoricoCSU,
    AtorCSU,
    ModalListCharters,
    DependenciasMap,
    AssociarRequisitoAoCSU,
  },
  data() {
    return {
      casoDeUso: null,
      fluxos: null,
      atores: [],
      atoresString: '',
      id: null,
      idProjeto: null,
      projeto: '',
      showDialog: false,
      showDialogDep: false,
      conteudoModalDep: null,
      isLoading: false,
      isLoadingRequisitos: false,
      keyHistorico: 0,
      keyCreateFluxo: 0,
      requisitos: null,
    };
  },
  computed: {
    casoDeUsoFormatado() {
      return {
        nome: this.casoDeUso.nome || '',
        prioridade: this.casoDeUso.prioridade || '',
        identificador: this.casoDeUso.identificador || '',
        descricao: this.casoDeUso.descricao || '',
        storypoint: this.casoDeUso.storypoint || '',
        gatilho: this.casoDeUso.gatilho || '',
        // eslint-disable-next-line camelcase
        pre_condicao: this.casoDeUso.pre_condicao || '',
        observacao: this.casoDeUso.observacao || '',
        status: this.casoDeUso.status || '',
      };
    },

    dataFormatada() {
      // console.log(this.casoDeUso);
      const data = new Date(this.casoDeUso.dt_cadastro);

      return data.toLocaleDateString('pt-BR');
    },
    isDev() {
      return localStorage.getItem('formaAtuacao') === '"DESENVOLVEDOR"';
    },
    isQA() {
      return localStorage.getItem('formaAtuacao') === '"TESTADOR"';
    },
  },
  watch: {
    id(newId, oldId) {
      // Se não for a primeira vez que o componente é carregado
      if (oldId !== null) {
        this.fetchCasoDeUso(newId);
        this.getFluxos(newId);
        this.keyHistorico += 1;
      }
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.idProjeto = this.$route.params.idProjeto;
    this.projeto = localStorage.getItem('projeto');
    this.fetchCasoDeUso(this.id);
    this.getFluxos(this.id);
    this.fetchAtores(this.id);
    this.getRequisitosByCasoDeUso();
  },
  methods: {
    /**
     * Formata as strings do enum;
     */
    converterTextoParaEnum(string) {
      /// PRIORIDADE.
      if (string === 'Urgente') {
        return 'URGENTE';
      } else if (string === 'Alta') {
        return 'ALTA';
      } else if (string === 'Média') {
        return 'MEDIA';
      } else if (string === 'Baixa') {
        return 'BAIXA';
      }
      /// TIPO REQUISITO.
      if (string === 'Restrição funcional') {
        return 'RESTRICAO_FUNCIONAL';
      } else if (string === 'Restrição organizacional') {
        return 'RESTRICAO_ORGANIZACIONAL';
      } else if (string === 'Restrição externa') {
        return 'RESTRICAO_EXTERNA';
      } else if (string === 'Restrição qualidade') {
        return 'RESTRICAO_QUALIDADE';
      }
    },
    converterEnumParaTexto(string) {
      /// PRIORIDADE.
      if (string === 'URGENTE') {
        return 'Urgente';
      } else if (string === 'ALTA') {
        return 'Alta';
      } else if (string === 'MEDIA') {
        return 'Média';
      } else if (string === 'BAIXA') {
        return 'Baixa';
      }
      /// TIPO REQUISITO.
      if (string === 'RESTRICAO_FUNCIONAL') {
        return 'Restrição funcional';
      } else if (string === 'RESTRICAO_ORGANIZACIONAL') {
        return 'Restrição organizacional';
      } else if (string === 'RESTRICAO_EXTERNA') {
        return 'Restrição externa';
      } else if (string === 'RESTRICAO_QUALIDADE') {
        return 'Restrição qualidade';
      }
    },
    /**
     * Obtém a lista de requisitos associados a um caso de uso.
     */
    async getRequisitosByCasoDeUso() {
      this.isLoadingRequisitos = true;
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(
          `${apiUrl}/api/v1/requisitos/csu/${this.id}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );
        this.requisitos = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingRequisitos = false;
      }
    },
    /**
     * Atualiza os fluxos após a criação, edição ou remoção de um fluxo.
     *
     * @param {String} id O id do caso de uso
     */
    onFluxosAlterados(id) {
      this.getFluxos(id);
      this.keyCreateFluxo += 1;
    },

    /**
     * Controla a visibilidade do modal que mostra detalhes da dependência.
     */
    toggleShowDialogDep() {
      this.showDialogDep = !this.showDialogDep;
    },

    /**
     * Insere o conteúdo dentro do modal que mostra detalhes da dependência.
     *
     * @param {Object} conteudo Informações sobre a dependência.
     */
    setConteudoModalDep(conteudo) {
      this.conteudoModalDep = conteudo;
    },

    /**
     * Controla a visibilidade do modal que mostra detalhes da dependência e
     * insere esses detalhes dentro do modal.
     *
     * @param {Object} conteudo Informações sobre a dependência.
     */
    toggleDep(conteudo) {
      this.toggleShowDialogDep();
      this.setConteudoModalDep(conteudo);
    },

    /**
     * Faz uma requisição HTTP para obter o caso de uso.
     *
     * @param {String} id O id do caso de uso
     */
    async fetchCasoDeUso(id) {
      this.isLoading = true;
      try {
        const response = await axios.get(
          `${apiUrl}/api/v1/productBacklog/${id}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );
        this.casoDeUso = response.data.useCase;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Remove o caso de uso.
     *
     * @param {Object} casoDeUso O objeto que representa o caso de uso
     */
    async deleteCasoDeUso(casoDeUso) {
      try {
        const response = await axios.patch(
          // eslint-disable-next-line max-len
          `${apiUrl}/api/v1/productBacklog/${casoDeUso.id_caso_de_uso}`,
          null,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );
        this.$toast.success(response.data.msg);
        this.$router.push(`/projects/${this.idProjeto}/CasoUso`);
      } catch (error) {
        console.log(error);
        this.$toast.error(error.response.data.msg);
      } finally {
        this.showDialog = false;
      }
    },

    /**
     * Obtém os fluxos relacionados ao caso de uso com o id especificado.
     *
     * @param {String} id O id do caso de uso
     */
    async getFluxos(id) {
      try {
        axios
          .get(`${apiUrl}/api/v1/fluxoCasoUso/csu/${id}`, {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          })
          .then((res) => {
            this.fluxos = res.data.fluxos.sort(this.compararPorTipoAtributo);
          });
      } catch (error) {
        console.log(error);
      }
    },

    compararPorTipoAtributo(a, b) {
      const tipos = ['PRINCIPAL', 'ALTERNATIVO', 'EXCECAO'];
      const tipoA = tipos.indexOf(a.tipo_fluxo);
      const tipoB = tipos.indexOf(b.tipo_fluxo);

      return tipoA - tipoB;
    },
    /**
     * Obtém os atores do caso de uso com o id especificado.
     *
     * @param {String} id O id do caso de uso
     */
    async fetchAtores(id) {
      try {
        const response = await axios.get(`${apiUrl}/api/v1/ator/${id}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        });
        var atores = response.data.ator;
        console.log(atores);
        atores.forEach((element) => {
          this.atores.push(element.nome_ator);
        });
        this.atoresString = this.atores.join(', ');
        console.log(this.atores);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style scoped>
.depItem {
  font-weight: bold;
  font-size: 12px;
  padding-bottom: 4px;
  padding-left: 0.5rem;
  padding-top: 4px;
  border-radius: 2px;
  margin-left: 1rem;
  /* border-bottom: 1px solid grey; */
}

.depItem:hover {
  background-color: rgba(156, 156, 156, 0.756);
  cursor: pointer;
}
.middleLine {
  width: 1px;
  background-color: grey;
}

.conteinerDep {
  height: 200px;
  overflow-y: scroll;
}

.mydivider {
  height: 2px;
}
</style>
